export function getProductDetailsUrl(
  productId: number,
  variantId?: number | null,
  routePattern = "/products/:id",
): string {
  const base = routePattern.replace(":id", String(productId));
  if (variantId == null) return base;
  return `${base}?variant=${variantId}`;
}
